import { cn } from "../../utils/classnames.js";
import { buttonVariants } from "./button-variants.js";
import "class-variance-authority";
import { jsx } from "react/jsx-runtime";
import { Button } from "@base-ui/react/button";
//#region src/components/atoms/button.tsx
const Button$1 = ({ expandOnHover = false, size, variant, className, ...props }) => {
	return /* @__PURE__ */ jsx(Button, {
		className: cn(buttonVariants({
			variant,
			size,
			className
		}), { "sm:hover:scale-105 hover:scale-102": expandOnHover }),
		"data-slot": "button",
		...props
	});
};
//#endregion
export { Button$1 as Button };

//# sourceMappingURL=button.js.map